import { createContext, Dispatch, SetStateAction } from 'react'
import { SectionStateType } from 'modules/profile/types'

export const PersonalInformationContext = createContext<{
  editingSection: SectionStateType
  setEditingSection: Dispatch<SetStateAction<SectionStateType>>
}>({
  editingSection: null,
  setEditingSection: () => null,
})
